export default __webpack_public_path__ + "static/badge_bee-8cd0406bb21ae492a6827e4439e5238c.png";